import { useState } from "react";

import PropTypes from "prop-types";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";

export const DeleteConfirmationDialog = ({ id, onClose, onSubmitted }) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const deleteDefaultGeneralProductVariant = async () => {
    try {
      setIsLoading(true);
      await apiClient.delete(
        `sales-order-default-general-product-variants/${id}`
      );
      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(
        getErrorMessage(error)
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>Konfirmasi Hapus</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Apakah Anda yakin ingin menghapus default varian produk ini?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="disabled">
          Batal
        </Button>
        <Button
          loading={isLoading}
          onClick={deleteDefaultGeneralProductVariant}
          color="error"
          variant="contained"
        >
          Ya, Hapus
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteConfirmationDialog.propTypes = {
  id: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
